import { render, staticRenderFns } from "./Subcategoria.vue?vue&type=template&id=28c441a5&scoped=true"
import script from "./Subcategoria.vue?vue&type=script&lang=js"
export * from "./Subcategoria.vue?vue&type=script&lang=js"
import style0 from "./Subcategoria.vue?vue&type=style&index=0&id=28c441a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c441a5",
  null
  
)

export default component.exports